module.exports = __webpack_public_path__ + "static/media/football-tv-program.48e061e0.svg";